import classNames from 'classnames';

function Button({ children, className, size = 'lg', ...props }) {
  return (
    <button
      {...props}
      className={classNames(
        className,
        'inline-grid place-items-center rounded-sm shadow-sm bg-mainBlue text-white hover:bg-opacity-95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-mainBlue px-4 sm:px-6',
        {
          'min-h-[3rem] sm:min-h-[3.5rem] min-w-[8rem] sm:min-w-[10rem] text-lg sm:text-xl': size === 'sm',
          'min-h-[3.5rem] sm:min-h-[4rem] md:min-h-[6rem] min-w-[10rem] sm:min-w-[12rem] md:min-w-[15rem] text-lg sm:text-xl md:text-3xl': size === 'lg',
        }
      )}
    >
      {children}
    </button>
  );
}

export default Button;
